import { render, staticRenderFns } from "./FollowupDetails.vue?vue&type=template&id=8cd2f222&scoped=true"
import script from "./FollowupDetails.vue?vue&type=script&lang=js"
export * from "./FollowupDetails.vue?vue&type=script&lang=js"
import style0 from "./FollowupDetails.vue?vue&type=style&index=0&id=8cd2f222&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cd2f222",
  null
  
)

export default component.exports